module.exports = __webpack_public_path__ + "img/tellertoteller.fw.5fb49d26.png";